if (!customElements.get("product-addons")) {
  customElements.define(
    "product-addons",
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.initShowMore();
        this.querySelectorAll("[data-addon-item]").forEach((item) => this.initItem(item));
      }

      initShowMore() {
        const button = this.querySelector("[data-addon-show-more]");
        if (!button) return;

        const wrapper = this.querySelector("[data-addon-show-more-wrapper]");
        const visibleItems = Array.from(this.querySelectorAll("[data-addon-item]:not([hidden])"));
        const lastVisibleItem = visibleItems[visibleItems.length - 1];

        lastVisibleItem?.classList.add("product-addons__item--before-show-more");

        button.addEventListener("click", () => {
          lastVisibleItem?.classList.remove("product-addons__item--before-show-more");

          this.querySelectorAll("[data-addon-hidden]").forEach((item) => {
            item.hidden = false;
            item.removeAttribute("data-addon-hidden");
          });

          button.setAttribute("aria-expanded", "true");
          if (wrapper) wrapper.hidden = true;
        });
      }

      initItem(item) {
        const checkbox = item.querySelector("[data-addon-checkbox]");

        if (checkbox) {
          const syncSelectedState = () => item.classList.toggle("product-addons__item--selected", checkbox.checked);

          checkbox.addEventListener("change", syncSelectedState);
          syncSelectedState();
        }

        const select = item.querySelector("[data-addon-option-select]");
        if (!select) return;

        const applySelectedOption = () => {
          const option = select.options[select.selectedIndex];
          if (!option) return;

          if (checkbox) checkbox.value = option.value;

          this.setPrices(item, option);
          this.setBadge(item, option);
          this.setImage(item, option);
        };

        select.addEventListener("change", applySelectedOption);
        applySelectedOption();
      }

      setPrices(item, option) {
        const finalPrice = item.querySelector("[data-addon-price-final]");
        if (finalPrice) finalPrice.textContent = option.dataset.finalMoney || "";

        const comparePrice = item.querySelector("[data-addon-price-compare]");
        if (!comparePrice) return;

        const compareMoney = option.dataset.compareMoney || "";
        comparePrice.textContent = compareMoney;
        comparePrice.hidden = !compareMoney;
      }

      setBadge(item, option) {
        const badge = item.querySelector("[data-addon-badge]");
        if (!badge) return;

        const hasDiscount = parseInt(option.dataset.discount || "0", 10) > 0;

        badge.textContent = hasDiscount ? option.dataset.discountLabel || "" : "";
        badge.hidden = !hasDiscount;
      }

      setImage(item, option) {
        const media = item.querySelector("[data-addon-media]");
        if (!media) return;

        const imageUrl = option.dataset.image || "";
        let image = media.querySelector("[data-addon-image]");
        let placeholder = media.querySelector("[data-addon-placeholder]");

        if (imageUrl) {
          if (!image) {
            image = document.createElement("img");
            image.setAttribute("data-addon-image", "");
            image.width = 80;
            image.height = 80;
            image.loading = "lazy";
            media.appendChild(image);
          }

          image.src = imageUrl;
          image.alt = option.dataset.imageAlt || "";
          placeholder?.remove();
          return;
        }

        image?.remove();

        if (!placeholder) {
          placeholder = document.createElement("div");
          placeholder.className = "product-addons__media-placeholder";
          placeholder.setAttribute("data-addon-placeholder", "");
          media.appendChild(placeholder);
        }
      }
    },
  );
}
